import { Badge } from "@/components/ui/badge";

const statusConfig = {
  DEMANDE_EN_LIGNE: {
    label: "Demande",
    labelFull: "Demande en ligne",
    className: "bg-cyan-100 text-cyan-700 border-cyan-200 hover:bg-cyan-100",
  },
  OPTION: {
    label: "Option",
    labelFull: "Option",
    className: "bg-yellow-100 text-yellow-700 border-yellow-200 hover:bg-yellow-100",
  },
  CONFIRME: {
    label: "Confirmé",
    labelFull: "Confirmé",
    className: "bg-green-100 text-green-700 border-green-200 hover:bg-green-100",
  },
  ANNULE: {
    label: "Annulé",
    labelFull: "Annulé",
    className: "bg-red-100 text-red-700 border-red-200 hover:bg-red-100",
  },
  BLOQUE: {
    label: "Bloqué",
    labelFull: "Bloqué",
    className: "bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-100",
  },
};

export const StatusBadge = ({ status, large = false, showNotification = false }) => {
  const config = statusConfig[status] || statusConfig.OPTION;

  return (
    <div className="relative inline-flex flex-shrink-0">
      <Badge
        variant="outline"
        className={`${config.className} ${
          large ? "px-4 py-1.5 text-sm" : "px-2 sm:px-3 py-1 text-[10px] sm:text-xs"
        } font-semibold uppercase tracking-wide rounded-full whitespace-nowrap`}
        data-testid={`status-badge-${status?.toLowerCase()}`}
      >
        <span className="sm:hidden">{config.label}</span>
        <span className="hidden sm:inline">{config.labelFull}</span>
      </Badge>
      {showNotification && (
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse" />
      )}
    </div>
  );
};

export default StatusBadge;
